import type { RibbonControlGroupDefinitionSLR, RibbonTabDefinitionBase } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { constructKeytip, SingleLine } from "owa-command-ribbon";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { getUniqueTabId } from "owa-mail-ribbon-utils/lib/getUniqueTabId";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import { getSLRSearchToolsTabControlDefinition } from "./getSLRSearchToolsTabControlDefinition";
import { getTabGroups } from "../../../util/getTabGroups";
import { getInitialScalingSteps } from "../../../util/getInitialScalingSteps";
import { getMailRibbonConfigStore } from "owa-mail-ribbon-store/lib/store/store";
import { search_tools_tab } from "../../../ribbon_search_tab.locstring.json";
import loc from "owa-localize";
import { controlsWithoutLabels, controlsDontDropLabels, controlsDontMoveToOverflow, controlsFirstMoveToOverflow, } from "./slrSearchTabScalingSpecialCases";
import { getScalingSteps } from "../../../util/getScalingSteps";

const getSLRSearchToolsTab: (props: ReadOnlyRibbonControlDefProps) => RibbonTabDefinitionBase = owaComputedFn(function getSLRSearchToolsTab(props: ReadOnlyRibbonControlDefProps): RibbonTabDefinitionBase {
    return {
        type: SingleLine,
        id: getUniqueTabId(14, undefined /* editorId */, props.itemId, props.isPopout),
        title: loc(search_tools_tab),
        controlGroups: { type: SingleLine, groups: getSearchToolsTabGroups(props) },
        initialScalingSteps: getInitialScalingSteps(getMailRibbonConfigStore(props.mailboxInfo).singleline.searchToolsTab, controlsWithoutLabels, undefined /*editorId*/, undefined /*itemId */),
        scalingSteps: getScalingSteps(getMailRibbonConfigStore(props.mailboxInfo).singleline.searchToolsTab.layout, getMailRibbonConfigStore(props.mailboxInfo).singleline.searchToolsTab
            .showLabelsPreference, controlsDontMoveToOverflow, controlsFirstMoveToOverflow, controlsDontDropLabels, undefined /*editorId*/, undefined /*itemId*/),
        keytipProps: constructKeytip([], 14, true /* hasMenu */),
    };
});
export default getSLRSearchToolsTab;

/**
 * Retrieves the groups within the Search Tools tab, as well as the actions that
 * fall under each group.
 * @returns an object that contains the sub-groups and corresponding actions of the
 * Search Tools tab
 */
const getSearchToolsTabGroups = owaComputedFn(function getSearchToolsTabGroups(props: ReadOnlyRibbonControlDefProps): RibbonControlGroupDefinitionSLR[] {
    const ribbonConfig = getMailRibbonConfigStore(props.mailboxInfo);
    const searchToolsTabConfig = ribbonConfig?.singleline?.searchToolsTab;
    let searchToolsTabGroups: RibbonControlGroupDefinitionSLR[] = new Array();
    searchToolsTabGroups = getTabGroups(14, searchToolsTabConfig.layout, getSLRSearchToolsTabControlDefinition, props);
    return searchToolsTabGroups;
});
